import React from 'react';
import PropTypes from 'prop-types';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import style from './style.module.less';

const ShipFromModalHeader = ({ children }) => {
  return <ModalHeader className={style['modal-header']}>{children}</ModalHeader>;
};

ShipFromModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ShipFromModalHeader;
